/**
 * Locations Section Component
 */

"use client";

import {JSX} from "react";

import {Locations} from "@/sections/content/locations/locations";

import {useTranslation} from "@/shared/i18n/use-translation";

import {mapLocationsSection} from "./mapper";
import type {ContentApiLocationsSection} from "./type";

interface LocationsSectionProps {
    data: ContentApiLocationsSection;
}

export function LocationsSection({data}: LocationsSectionProps): JSX.Element | null {
    const {t} = useTranslation("locations");

    // Map Content API data directly to LocationsProps
    const props = mapLocationsSection(data, t as (key: string) => string);

    return <Locations {...props} />;
}
